import React from 'react';
import { FacebookIcon, InstagramIcon } from 'lucide-react';
import { contact, navLinks } from '../data/site';
export function SiteFooter() {
  return <footer className="w-full bg-forest-950 pt-20 pb-10" data-id="element-70" data-mp="3raccci24vwxa">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-71" data-mp="3mghmewvxqlpr">
        <div className="flex flex-col gap-10 md:flex-row md:items-end md:justify-between" data-id="element-72" data-mp="3hig3cbyiemea">
          <div data-id="element-73" data-mp="3hglqlkxe60la">
            <p className="font-serif text-5xl font-light text-cream-50 md:text-6xl" data-id="element-74" data-mp="3dgl3zd052j35">Le Bistrot</p>
            <p className="font-script -mt-2 text-6xl text-ember-400 md:text-7xl" data-id="element-75" data-mp="38i1g371zix85">Jeanot</p>
          </div>
          <nav aria-label="Pied de page" data-id="element-76" data-mp="33if5l5djjv31">
            <ul className="flex flex-wrap gap-x-8 gap-y-3" data-id="element-77" data-mp="33j6xo67xjaok">
              {navLinks.map(l => <li key={l.href} data-id="element-78" data-mp="2yl55mvsj010y">
                  <a href={l.href} className="text-sm text-cream-100/70 transition-colors duration-150 hover:text-cream-50" data-id="element-79" data-mp="11rbqa2sphsc5">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-14 flex flex-col gap-6 border-t border-cream-100/10 pt-8 text-xs text-cream-100/50 sm:flex-row sm:items-center sm:justify-between" data-id="element-80" data-mp="15q26weh50m4g">
          <p data-id="element-81" data-mp="vt7d28vt79wi">© {new Date().getFullYear()} Le Bistrot Jeanot · Restaurant & bar à vin · {contact.city}</p>
          <div className="flex items-center gap-4" data-id="element-82" data-mp="10r8w4tt8j97z">
            <a href={contact.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="text-cream-100/70 hover:text-cream-50" data-id="element-83" data-mp="10tv24p0h9go3">
              <FacebookIcon className="h-4 w-4" data-id="element-84" data-mp="1tgzan3ys4d4m" />
            </a>
            <a href={contact.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="text-cream-100/70 hover:text-cream-50" data-id="element-85" data-mp="1tiagd9bsbuyd">
              <InstagramIcon className="h-4 w-4" data-id="element-86" data-mp="1jpl6givvup55" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}